import { AppThunk } from '../../root.reducer'
import api from './password.api'
import {
  SHOW_LOADING,
  HIDE_LOADING,
  OPEN_DIALOG,
  CLOSE_DIALOG,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHECK_PASSWORD_STRENGTH_SUCCESS,
  CHECK_PASSWORD_STRENGTH_FAILURE,
} from './password.constants'

export const showLoading = () => ({
  type: SHOW_LOADING,
}) as const

export const hideLoading = () => ({
  type: HIDE_LOADING,
}) as const

export const openDialog = () => ({
  type: OPEN_DIALOG,
}) as const

export const closeDialog = () => ({
  type: CLOSE_DIALOG,
}) as const

export const changePasswordSuccess = (info: $TSFIXME) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  info,
}) as const

export const changePasswordFailure = (error: unknown) => ({
  type: CHANGE_PASSWORD_FAILURE,
  error,
}) as const

export const checkPasswordStrengthSuccess = (status: $TSFIXME) => ({
  type: CHECK_PASSWORD_STRENGTH_SUCCESS,
  status,
}) as const

export const checkPasswordStrengthFailure = (error: unknown) => ({
  type: CHECK_PASSWORD_STRENGTH_FAILURE,
  error,
}) as const

export const changePassword = (currentPassword: string, newPassword: string): AppThunk => {
  return async dispatch => {
    try {
      dispatch(showLoading())
      const info = await api.changePassword(currentPassword, newPassword)
      dispatch(changePasswordSuccess(info))
    } catch (e) {
      dispatch(changePasswordFailure(e))
    } finally {
      dispatch(hideLoading())
    }
  }
}

export const checkPasswordStrength = (password: string): AppThunk => {
  return async dispatch => {
    try {
      const strength = await api.checkPasswordStrength(password)
      dispatch(checkPasswordStrengthSuccess(strength))
    } catch (e) {
      dispatch(checkPasswordStrengthFailure(e))
    }
  }
}

export type PasswordAction = ReturnType<
  | typeof showLoading
  | typeof hideLoading
  | typeof openDialog
  | typeof closeDialog
  | typeof changePasswordSuccess
  | typeof changePasswordFailure
  | typeof checkPasswordStrengthSuccess
  | typeof checkPasswordStrengthFailure
>
